import React from "react";
import {
  PostiLogo,
  TopBar,
  Button,
  NavButton,
} from "@postidigital/posti-components";
import { useTranslation } from "react-i18next";
export default function CommonFooter() {
  const  {t}  = useTranslation();

  return (
    <div className="footer">
      <div className="footerLinks">
        <NavButton
          className="terms"
          onClick={function noRefCheck() {}}
          title={t("TERMS_AND_CONDITIONS")}
          withArrow={false}
        />

        <div className="footerDivision"></div>
        <NavButton
          className="privacy"
          onClick={function noRefCheck() {}}
          title={t("PRIVACY_POLICY")}
          withArrow={false}
        />
      </div>
    </div>
  );
}
